define.alias("shared/components/shared/post/secondary/activity/comment", "calendar/components/shared/post/secondary/activity/comment");